import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Pagination } from '@mui/material';
import axios from '../../helpers/axios';
import { formatDate } from '../../helpers/custom';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Tooltip, Chip, Backdrop, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, Box, CardActions, Divider, Typography, FormControl, InputLabel, Select, MenuItem, TextField, ToggleButtonGroup, ToggleButton, OutlinedInput, Autocomplete } from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineOppositeContent, TimelineDot } from '@mui/lab';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, ArrowDownward, ArrowUpward, AccessTime, PersonOutline, HistoryOutlined, CancelPresentationOutlined, DeleteOutline, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import debounce from 'lodash.debounce';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    height: '80%',
    overflowY: 'scroll',
    p: 4,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
    return (
        <Pagination
            count={count}
            page={page}
            onChange={onChange}
            color="primary"
            shape="rounded"
            variant="outlined"
            showFirstButton
            showLastButton
            
        
        
        
        />
    );
} 


export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    batch_pickups: any[];
    rowCount: number;
    pageSize: number;
    routes: any[];
    filter: string;
    filter_routes: any;
    filter_pickup_date?: string | null;
    start_date?: string | null;
    end_date?: string | null;
    showCheckinDialog: boolean;
    showCheckoutDialog: boolean;
    showTimeline: boolean;
    batchPickupTimeline: any[];
    showChangeBatchAgent: boolean;
    agents: any[];
    newBatchAgentId: string;
    showRescheduleBatchPickup: boolean;
    slots: any[];
    newPickupDate: string;
    newSlotId: string;
    showCancelDialog: boolean;
    showDeleteDialog: boolean;
    selectedBatchPickup: any;
    currentPage:number
}

class BatchPickups extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            batch_pickups: [],
            rowCount: 0,
            pageSize: 10,
            currentPage:0,
            routes: [],
            filter: '',
            filter_routes: [],
            filter_pickup_date: null,
            start_date: null,
            end_date: null,
            showCheckinDialog: false,
            showCheckoutDialog: false,
            showTimeline: false,
            batchPickupTimeline: [],
            showChangeBatchAgent: false,
            agents: [],
            newBatchAgentId: '',
            showRescheduleBatchPickup: false,
            slots: [],
            newPickupDate: '',
            newSlotId: '',
            showCancelDialog: false,
            showDeleteDialog: false,
            selectedBatchPickup: {}
        }
    }
    public componentDidMount(): void {
        this.fetchBatchPickups();
        this.fetchAgents();
        this.fetchSlots();
        this.fetchRoutes();

    }

    public fetchBatchPickups(page: number = 0, limit: number = this.state.pageSize) {
        this.setState({ showLoader: true ,currentPage:page});
        let selectedRoutes: any = [];
        this.state.filter_routes.map((route: any) => {
            selectedRoutes.push(route.id);
        });
        let start_date = (this.state.start_date) ? formatDate(this.state.start_date, 'Y-m-d') : "";
        let end_date = (this.state.end_date) ? formatDate(this.state.end_date, 'Y-m-d') : "";

        let data = { "communities": selectedRoutes, "filter": this.state.filter, "hierarchies": this.props.user.selectedHierarchyIds, "limit": limit, "page": page + 1, "start_date": start_date, "end_date": end_date}
        axios.post(`allBatchPickup`, data, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            this.setState({ showLoader: false });
            let data: any = response.data.data.data;
            let batch_pickups: any = [];
            data.map((batch_pickup: any) => {
                let customClassNames = [];
                if (batch_pickup.rescheduled_to > 0) {
                    customClassNames.push('pickupIsRescheduledClass');
                }
                if (batch_pickup.pickup_count && batch_pickup.pending_count && (batch_pickup.pickup_count.count == batch_pickup.pending_count.count)) {
                    customClassNames.push('pickupPendingClass');
                }
                if (batch_pickup.pickup_count && batch_pickup.complete_count && (batch_pickup.pickup_count.count == batch_pickup.complete_count.count)) {
                    customClassNames.push('pickupCompleteClass');
                }
                let pendingPickups = batch_pickup.pending_count ? batch_pickup.pending_count.count : 0;
                let totalPickups = batch_pickup.pickup_count ? batch_pickup.pickup_count.count : 0;
                let completedPickups = batch_pickup.complete_count ? batch_pickup.complete_count.count : 0;
                if (totalPickups != completedPickups && pendingPickups == 0 && totalPickups > 0) {
                    customClassNames.push('pickupPartCompleteClass');
                }
                batch_pickups.push({
                    "id": batch_pickup.id,
                    "route_name": batch_pickup.community.name,
                    "pickups": {
                        "completed": batch_pickup.complete_count ? batch_pickup.complete_count.count : 0,
                        "collected": batch_pickup.collected_count ? batch_pickup.collected_count.count : 0,
                        "cancelled": batch_pickup.cancelled_count ? batch_pickup.cancelled_count.count : 0,
                        "rescheduled": batch_pickup.rescheduled_count ? batch_pickup.rescheduled_count.count : 0,
                        "pending": batch_pickup.pending_count ? batch_pickup.pending_count.count : 0,
                        "total": batch_pickup.pickup_count ? batch_pickup.pickup_count.count : 0,
                    },
                    "pickup_date": batch_pickup.pickup_date,
                    "slot_id": (batch_pickup.slot) ? batch_pickup.slot.id : 'NA',
                    "slot": (batch_pickup.slot) ? batch_pickup.slot.text : 'NA',
                    "agent_id": (batch_pickup.agent) ? batch_pickup.agent.id : '',
                    "agent": (batch_pickup.agent) ? batch_pickup.agent.name : 'NA',
                    "is_check_in": batch_pickup.is_check_in,
                    "is_check_out": batch_pickup.is_check_out,
                    "status": batch_pickup.status,
                    "created_at": batch_pickup.created_at,
                    "updated_at": batch_pickup.updated_at,
                    "customClassNames": customClassNames.join(" ")
                });
            });
            this.setState({ batch_pickups: batch_pickups, rowCount: response.data.data.total });
        }).catch((error) => {
            this.setState({
                showLoader: false
            });
            toast.error(error.response.data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public fetchAgents() {
        if (this.props.user.selectedHierarchyIds.length) {
            this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds }
            axios.get(`allAgentsLite`, { params: options }).then((response: any) => {
                this.setState({ showLoader: false });
                let agents: any = response.data.data;
                this.setState({ agents: agents });
            });
        }
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchBatchPickups(page, limit);
    }, 800);

    public fetchSlots() {
        if (this.props.user.selectedHierarchyIds.length) {
            this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds }
            axios.get(`allSlotLite`, { params: options }).then((response: any) => {
                this.setState({ showLoader: false });
                let slots: any = response.data.data;
                this.setState({ slots: slots });
            });
        }
    }

    public fetchRoutes() {
        axios.get(`allCommunitiesLite`, {
            params: { hierarchies: this.props.user.selectedHierarchyIds },
        }).then((response) => {
            let data: any = response.data.data;
            let routes: any = [];
            data.map((route: any) => {
                routes[route.id] = {
                    id: route.id,
                    route: route.name,
                    hierarchy_id: route.hierarchy_id,
                    hierarchy_name: route.hierarchy_name,
                };
            });
            this.setState({ routes: routes });
        });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const timelineTypes: any = {
            "pickup": "Cancelled",
            "check_in": "Check In",
            "check_out": "Check Out",
        };

        const handleCellClick = (params: GridCellParams) => {
            console.log(params);
        };

        const openCheckinDialog = (pickupDetails: any) => {
            this.setState({
                showCheckinDialog: true,
                selectedBatchPickup: pickupDetails
            });
        }

        const openCheckOutDialog = (pickupDetails: any) => {
            this.setState({
                showCheckoutDialog: true,
                selectedBatchPickup: pickupDetails
            });
        }

        const openTimeline = (pickupDetails: any) => {
            this.setState({ showLoader: true, batchPickupTimeline: [] });
            let options = { "community_pickup_group_id": pickupDetails.id, "hierarchies": this.props.user.selectedHierarchyIds }
            axios.post(`batchPickupTimeline`, options).then((response: any) => {
                this.setState({ showLoader: false });
                let data: any = response.data.data;
                let batchPickupTimeline: any = [];
                data.map((item: any) => {
                    let timelineItem = item;
                    if (timelineItem.type == "check_in") {
                        // timelineItem.comment = item.user_name + ' (' + item.user_type + ') Check In at ' + item.time;
                        timelineItem.comment = 'Check In by ' + item.user_name + ' (' + item.user_type + ')';
                    } else if (timelineItem.type == "check_out") {
                        // timelineItem.comment = item.user_name + ' (' + item.user_type + ') Check Out at ' + item.time;
                        timelineItem.comment = 'Check Out by ' + item.user_name + ' (' + item.user_type + ')';
                    }
                    batchPickupTimeline.push(timelineItem);
                });
                this.setState({ showTimeline: true, selectedBatchPickup: pickupDetails, batchPickupTimeline: batchPickupTimeline });
                console.log("batchPickupTimeline", this.state.batchPickupTimeline);
            }).catch((error) => {
                this.setState({
                    showLoader: false
                });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
            this.setState({
                showTimeline: true,
                selectedBatchPickup: pickupDetails
            });
        }

        const openChangeBatchAgent = (pickupDetails: any) => {
            this.setState({
                showChangeBatchAgent: true,
                selectedBatchPickup: pickupDetails,
                newBatchAgentId: pickupDetails.agent_id
            });
        }

        const openRescheduleBatchPickup = (pickupDetails: any) => {
            this.setState({
                showRescheduleBatchPickup: true,
                selectedBatchPickup: pickupDetails,
                newBatchAgentId: pickupDetails.agent_id,
                newPickupDate: pickupDetails.pickup_date,
                newSlotId: pickupDetails.slot_id
            });
        }

        const openCancelDialog = (pickupDetails: any) => {
            this.setState({
                showCancelDialog: true,
                selectedBatchPickup: pickupDetails
            });
        }

        const openDeleteDialog = (pickupDetails: any) => {
            this.setState({
                showDeleteDialog: true,
                selectedBatchPickup: pickupDetails
            });
        }

        const handleBatchPickupStateUpdate = (type: string) => {
            this.setState({ showLoader: true });
            let data = {
                agent_id: this.state.selectedBatchPickup.agent_id,
                community_pickup_group_id: this.state.selectedBatchPickup.id,
                type: type
            };
            axios.post(`batchPickupStateUpdate`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showCheckinDialog: false, showCheckoutDialog: false, selectedBatchPickup: {}, showLoader: false });
                toast.success(((type == 'check_in') ? 'Check In' : 'Check Out') + ' Successful', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchBatchPickups();
            }).catch((error) => {
                this.setState({ showCheckinDialog: false, showCheckoutDialog: false, selectedBatchPickup: {}, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleChangeBatchAgent = (() => {
            this.setState({ showLoader: true });
            let data = {
                agent_id: this.state.newBatchAgentId,
                community_pickup_group_id: this.state.selectedBatchPickup.id
            };
            axios.post(`updateBatchAgent`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showChangeBatchAgent: false, newBatchAgentId: "", showLoader: false });
                toast.success('Batch Agent Changed Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchBatchPickups();
            }).catch((error) => {
                this.setState({ showChangeBatchAgent: false, newBatchAgentId: "", showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        const handleReschedule = (() => {
            this.setState({ showLoader: true });
            let data = {
                agent_id: this.state.newBatchAgentId,
                community_pickup_group_id: this.state.selectedBatchPickup.id,
                pickup_date: this.state.newPickupDate,
                slot_id: this.state.newSlotId
            };
            axios.post(`rescheduleBatchPickup`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showRescheduleBatchPickup: false, newBatchAgentId: "", showLoader: false });
                toast.success('Rescheduled All Pickups Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchBatchPickups();
            }).catch((error) => {
                this.setState({ showRescheduleBatchPickup: false, newBatchAgentId: "", showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        const handleCancelBatchPickup = () => {
            this.setState({ showLoader: true });
            let data = {
                community_pickup_group_id: this.state.selectedBatchPickup.id
            };
            axios.post(`cancelBatchPickup`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showCancelDialog: false, selectedBatchPickup: {}, showLoader: false });
                toast.success('Cancelled All Pickups Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchBatchPickups();
            }).catch((error) => {
                this.setState({ showCancelDialog: false, selectedBatchPickup: {}, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleDeleteBatchPickup = () => {
            this.setState({ showLoader: true });
            let data = {
                batch_id: this.state.selectedBatchPickup.id
            };
            axios.post(`deleteBatch`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showDeleteDialog: false, selectedBatchPickup: {}, showLoader: false });
                toast.success('Deleted All Pickups Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchBatchPickups();
            }).catch((error) => {
                this.setState({ showDeleteDialog: false, selectedBatchPickup: {}, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 100
            },
            {
                headerName: t("Route"),
                field: "route_name",
                width: 180
            },
            {
                headerName: t("Pickups"),
                field: "pickups",
                width: 220,
                renderCell: (params: GridCellParams) => (
                    <div>
                        <Tooltip title="Completed Pickups"><Chip size="small" color="success" className="pickupCountChip" style={{ cursor: 'pointer' }} label={params.row.pickups.completed} /></Tooltip>
                        <Tooltip title="Collected Pickups"><Chip size="small" color="primary" className="pickupCountChip" style={{ cursor: 'pointer' }} label={params.row.pickups.collected} /></Tooltip>
                        <Tooltip title="Cancelled Pickups"><Chip size="small" color="error" className="pickupCountChip"   style={{ cursor: 'pointer' }}  label={params.row.pickups.cancelled} /></Tooltip>
                        <Tooltip title="Rescheduled Pickups"><Chip size="small" color="default" className="pickupCountChip" style={{ cursor: 'pointer' }} label={params.row.pickups.rescheduled} /></Tooltip>
                        <Tooltip title="Pending Pickups"><Chip size="small" color="warning" className="pickupCountChip" style={{ cursor: 'pointer' }} label={params.row.pickups.pending} /></Tooltip><span>/</span>
                        <Tooltip title="Total Pickups"><Chip size="small" color="info" className="pickupCountChip" style={{ cursor: 'pointer' }}  label={params.row.pickups.total} /></Tooltip>
                    </div>
                )
            },
            {
                headerName: t("Pickup Date"),
                field: "pickup_date",
                type: "date",
                width: 100
            },
            {
                headerName: t("Slot"),
                field: "slot",
                width: 100
            },
            {
                headerName: t("Agent"),
                field: "agent",
                // width: 150
            },
            {
                headerName: t("Added"),
                field: "created_at",
                type: "dateTime",
                width: 170
            },
            {
                headerName: t("Edited"),
                field: "updated_at",
                type: "dateTime",
                width: 170
            },
            {
                headerName: t("Actions"),
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => {
                    let actions: any = [];
                    if (!params.row.is_check_in) {
                        actions.push(
                            <GridActionsCellItem
                                icon={<ArrowDownward />}
                                label={t("CheckIn")}
                                onClick={() => openCheckinDialog(params.row)}
                                showInMenu
                            />
                        );
                    }
                    if (params.row.is_check_in && !params.row.is_check_out) {
                        actions.push(
                            <GridActionsCellItem
                                icon={<ArrowUpward />}
                                label={t("CheckOut")}
                                onClick={() => openCheckOutDialog(params.row)}
                                showInMenu
                            />
                        );
                    }
                    actions.push(
                        <GridActionsCellItem
                            icon={<AccessTime />}
                            label={t("Timeline")}
                            onClick={() => openTimeline(params.row)}
                            showInMenu
                        />
                    );
                    actions.push(
                        <GridActionsCellItem
                            icon={<PersonOutline />}
                            label={t("Change Batch Agent")}
                            onClick={() => openChangeBatchAgent(params.row)}
                            showInMenu
                            disabled={(params.row.pickups.pending == 0)}
                        />
                    );
                    actions.push(
                        <GridActionsCellItem
                            icon={<HistoryOutlined />}
                            label={t("Reschedule")}
                            onClick={() => openRescheduleBatchPickup(params.row)}
                            showInMenu
                            disabled={(params.row.pickups.pending == 0)}
                        />
                    );
                    actions.push(
                        <GridActionsCellItem
                            icon={<CancelPresentationOutlined />}
                            label={t("Cancel Batch")}
                            onClick={() => openCancelDialog(params.row)}
                            showInMenu
                            disabled={params.row.status == "cancelled"}
                        />
                    );
                    if (params.row.status == "cancelled") {
                        actions.push(
                            <GridActionsCellItem
                                icon={<DeleteOutline />}
                                label={t("Delete Batch")}
                                onClick={() => openDeleteDialog(params.row)}
                                showInMenu
                            />
                        );
                    }
                    return actions;
                    /*return [
                        <GridActionsCellItem
                            icon={<ArrowDownward />}
                            label={(!params.row.is_check_in) ? "Check In" : "Check Out"}
                            onClick={() => openCheckinDialog(params.row)}
                            showInMenu
                        />,
                        <GridActionsCellItem
                            icon={<AccessTime />}
                            label="Timeline"
                            onClick={() => console.log(params.id)}
                            showInMenu
                        />,
                        <GridActionsCellItem
                            icon={<PersonOutline />}
                            label="Change Batch Agent"
                            onClick={() => console.log(params.id)}
                            showInMenu
                        />,
                        <GridActionsCellItem
                            icon={<HistoryOutlined />}
                            label="Reschedule"
                            onClick={() => console.log(params.id)}
                            showInMenu
                        />,
                        <GridActionsCellItem
                            icon={<CancelPresentationOutlined />}
                            label="Cancel Batch"
                            onClick={() => console.log(params.id)}
                            showInMenu
                        />
                    ]*/
                }
            }
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card style={{height: 600}}>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Community Batch Pickup List")}</Typography>
                                        </Grid>
                                        {/* <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.handleSearch())}
                                                    fullWidth={true}
                                                    size='small'
                                                />
                                            </FormControl>
                                        </Grid> */}
                                        <Grid item md={4} xs={12}>
                                            <FormControl fullWidth={true} size='small'>
                                                <Autocomplete
                                                    multiple
                                                    id={"communities"}
                                                    options={this.state.routes}
                                                    isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                    getOptionLabel={(option: any) => option.route}
                                                    value={this.state.filter_routes}
                                                    onChange={(e: any, value: any) => this.setState({ filter_routes: value }, () => this.fetchBatchPickups())}
                                                    renderInput={(params: any) => (
                                                        <TextField
                                                            {...params}
                                                            label={t("Communities")}
                                                            placeholder={t("Select Communities")}
                                                            size='small'
                                                        />
                                                    )}
                                                    size='small'
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        inputFormat="yyyy-MM-dd"
                                                        mask="____-__-__"
                                                        views={['year', 'month', 'day']}
                                                        renderInput={(props) => <TextField {...props} size='small' />}
                                                        label={t("Start Date")}
                                                        value={this.state.start_date}
                                                        onChange={(newValue: any) => this.setState({ start_date: newValue }, () => this.fetchBatchPickups())}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        inputFormat="yyyy-MM-dd"
                                                        mask="____-__-__"
                                                        views={['year', 'month', 'day']}
                                                        renderInput={(props) => <TextField {...props} size='small' />}
                                                        label={t("End Date")}
                                                        value={this.state.end_date}
                                                        onChange={(newValue: any) => this.setState({ end_date: newValue }, () => this.fetchBatchPickups())}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                }
                                className="text-left"
                            />
                            <CardContent >
                                <DataGrid
                                    aria-label={t("Batch Pickup List")}
                                    columns={columns}
                                    rows={this.state.batch_pickups}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchBatchPickups(page)}
                                    onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }); this.fetchBatchPickups(0, newPageSize); }}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    style={{ height: 500 }}
                                    pagination
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/operations/batch-pickups/group-pickups/' + params.id)
                                    }}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Pagination: () => (
                                            <div style={{ paddingBottom: '20px' }}>
                                            <CustomPagination
                                                count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                                                page={this.state.currentPage+1}
                                                onChange={(event, page) => this.fetchBatchPickups(page-1)}
                                              
                                                />
                                                </div>
                                        )
                                    }}
                                    className="clickableList"
                                    paginationMode="server"
                                    getRowClassName={(params: any) =>
                                        params.row.customClassNames
                                    }
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.showCheckinDialog}
                    onClose={() => this.setState({ showCheckinDialog: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to check in this batch ?")}
                    </DialogTitle>
                    {/* <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Let Google help apps determine location. This means sending anonymous
                            location data to Google, even when no apps are running.
                        </DialogContentText>
                    </DialogContent> */}
                    <DialogActions>
                        <Button onClick={() => this.setState({ showCheckinDialog: false })}>{t("Cancel")}</Button>
                        <Button onClick={() => handleBatchPickupStateUpdate('check_in')} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.showCheckoutDialog}
                    onClose={() => this.setState({ showCheckoutDialog: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to check in this batch ?")}
                    </DialogTitle>
                    {/* <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Let Google help apps determine location. This means sending anonymous
                            location data to Google, even when no apps are running.
                        </DialogContentText>
                    </DialogContent> */}
                    <DialogActions>
                        <Button onClick={() => this.setState({ showCheckoutDialog: false })}>{t("Cancel")}</Button>
                        <Button onClick={() => handleBatchPickupStateUpdate('check_out')} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
                <Modal
                    open={this.state.showTimeline}
                    onClose={() => this.setState({ showTimeline: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Batch Timeline") + ((this.state.selectedBatchPickup) ? ' of ' + this.state.selectedBatchPickup.route_name : '')}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showTimeline: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container>
                                    <Grid item md={12} xs={12}>
                                        <Timeline position="alternate">
                                            {
                                                (this.state.batchPickupTimeline.length == 0) && <Typography align='center'>{t("No Data Found")}</Typography>
                                            }
                                            {
                                                this.state.batchPickupTimeline.map((timelineItem: any, key: number) => {
                                                    return (
                                                        <TimelineItem key={key} position={(timelineItem.status == "cancelled") ? 'right' : 'left'}>
                                                            <TimelineOppositeContent
                                                                sx={{ m: 'auto 0' }}
                                                                align={(timelineItem.status == "cancelled") ? "right" : "left"}
                                                                variant="body2"
                                                                color="text.secondary"
                                                            >
                                                                {timelineItem.time}
                                                            </TimelineOppositeContent>
                                                            <TimelineSeparator>
                                                                <TimelineConnector />
                                                                <TimelineDot color={(timelineItem.type == 'pickup') ? "error" : "success"}>
                                                                    {(timelineItem.type == 'check_in') && <ArrowDownward />}
                                                                    {(timelineItem.type == 'check_out') && <ArrowUpward />}
                                                                    {(timelineItem.type == 'pickup') && <CancelPresentationOutlined />}
                                                                </TimelineDot>
                                                                <TimelineConnector />
                                                            </TimelineSeparator>
                                                            <TimelineContent sx={{ py: '12px', px: 2 }}>
                                                                <Typography variant="subtitle1" component="span">
                                                                    {((timelineItem.type == 'pickup') ? '#' + timelineItem.house + ' - ' : '') + timelineTypes[timelineItem.type]}
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ fontStyle: 'italic' }}>{((timelineItem.type == 'pickup') ? 'Pickup (#' + timelineItem.pickup_id + ') ' : '') + timelineItem.comment}</Typography>
                                                            </TimelineContent>
                                                        </TimelineItem>
                                                    )
                                                })
                                            }
                                        </Timeline>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showTimeline: false })}>{t("Close")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showChangeBatchAgent}
                    onClose={() => this.setState({ showChangeBatchAgent: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={"Change Batch Agent " + ((this.state.selectedBatchPickup.route_name) ? ' of ' + this.state.selectedBatchPickup.route_name : '')}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showChangeBatchAgent: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="payment-agent-label">{t("Batch Agent")} *</InputLabel>
                                            <Select
                                                labelId="payment-agent-label"
                                                value={this.state.newBatchAgentId}
                                                onChange={(e) => this.setState({ newBatchAgentId: e.target.value })}
                                                displayEmpty
                                                label={t("BatchAgent") + " *"}
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.agents.map((agent: any, key: number) => {
                                                        return (<MenuItem key={key} value={agent.id}>{agent.name}</MenuItem>);
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showChangeBatchAgent: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleChangeBatchAgent()}>{t("Update Batch Agent")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showRescheduleBatchPickup}
                    onClose={() => this.setState({ showRescheduleBatchPickup: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Reschedule Batch") + ((this.state.selectedBatchPickup.route_name) ? ' of ' + this.state.selectedBatchPickup.route_name : '')}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showRescheduleBatchPickup: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="payment-agent-label">{t("Batch Agent")} *</InputLabel>
                                            <Select
                                                labelId="payment-agent-label"
                                                value={this.state.newBatchAgentId}
                                                onChange={(e) => this.setState({ newBatchAgentId: e.target.value })}
                                                displayEmpty
                                                label={t("Batch Agent") + " *"}
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.agents.map((agent: any, key: number) => {
                                                        return (<MenuItem key={key} value={agent.id}>{agent.name}</MenuItem>);
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("From Date") + " *"}
                                                    value={this.state.newPickupDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ newPickupDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <ToggleButtonGroup
                                            color="success"
                                            value={this.state.newSlotId}
                                            exclusive
                                            onChange={(event: any, value: string) => this.setState({ newSlotId: value })}
                                        >
                                            {
                                                this.state.slots.map((slot: any, key: number) => {
                                                    return (<ToggleButton key={key} value={slot.id}>{slot.text}</ToggleButton>)
                                                })
                                            }
                                        </ToggleButtonGroup>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showRescheduleBatchPickup: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleReschedule()}>{t("Confirm Reschedule")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Dialog
                    open={this.state.showCancelDialog}
                    onClose={() => this.setState({ showCancelDialog: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to cancel this batch ?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showCancelDialog: false })}>{t("Cancel")}</Button>
                        <Button onClick={() => handleCancelBatchPickup()} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.showDeleteDialog}
                    onClose={() => this.setState({ showDeleteDialog: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to delete this batch ?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showDeleteDialog: false })}>{t("Cancel")}</Button>
                        <Button onClick={() => handleDeleteBatchPickup()} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withRouter(withTranslation()(BatchPickups))